module.exports = __webpack_public_path__ + "media/images/countrysquared/mh-ceed7fdc1db2550a75b1e44f54b89d40.svg";